import {
  CuratedColumnSymbology,
  CUSTOM_THEME,
  DEFAULT_OPACITY,
  DistributionTypes,
  InterpolationTypes,
  PaintColorTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/hud_low_poverty_idx': {
    pov_idx: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': {
            property: 'pov_idx',
            type: PaintColorTypes.INTERVAL,
            stops: [
              { value: 0.1, label: '0 to 19', color: '#b42832' },
              { value: 20, label: '20 to 39', color: '#ea8f73' },
              { value: 40, label: '40 to 59', color: '#f8eae2' },
              { value: 60, label: '60 to 79', color: '#95c5de' },
              { value: 80, label: '80 to 100', color: '#357eb8' },
            ],
          },
          'fill-opacity': DEFAULT_OPACITY,
        },
        display_hints: {
          scale: SymbologyScales.NUMERIC,
          distribution: DistributionTypes.DEFAULT,
          interpolation: InterpolationTypes.INTERVAL,
          theme: CUSTOM_THEME,
        },
      },
    ],
  },
};

export default symbologies;
